export default __webpack_public_path__ + "static/media/likeOutlined.4ef56614.svg";